export const PAYMENTS_PROVIDERS_REQUEST = 'PAYMENTS_PROVIDERS_REQUEST';
export const PAYMENTS_PROVIDERS_SUCCESS = 'PAYMENTS_PROVIDERS_SUCCESS';
export const PAYMENTS_PROVIDERS_FAILURE = 'PAYMENTS_PROVIDERS_FAILURE';

export const PAYMENTS_METHODS_REQUEST = 'PAYMENTS_METHODS_REQUEST';
export const PAYMENTS_METHODS_SUCCESS = 'PAYMENTS_METHODS_SUCCESS';
export const PAYMENTS_METHODS_FAILURE = 'PAYMENTS_METHODS_FAILURE';

export const PAYMENTS_CREATE_METHOD_REQUEST = 'PAYMENTS_CREATE_METHOD_REQUEST';
export const PAYMENTS_CREATE_METHOD_SUCCESS = 'PAYMENTS_CREATE_METHOD_SUCCESS';
export const PAYMENTS_CREATE_METHOD_FAILURE = 'PAYMENTS_CREATE_METHOD_FAILURE';

export const PAYMENTS_UPDATE_METHOD_REQUEST = 'PAYMENTS_UPDATE_METHOD_REQUEST';
export const PAYMENTS_UPDATE_METHOD_SUCCESS = 'PAYMENTS_UPDATE_METHOD_SUCCESS';
export const PAYMENTS_UPDATE_METHOD_FAILURE = 'PAYMENTS_UPDATE_METHOD_FAILURE';

export const PAYMENTS_SET_PRIMARY_REQUEST = 'PAYMENTS_SET_PRIMARY_REQUEST';
export const PAYMENTS_SET_PRIMARY_SUCCESS = 'PAYMENTS_SET_PRIMARY_SUCCESS';
export const PAYMENTS_SET_PRIMARY_FAILURE = 'PAYMENTS_SET_PRIMARY_FAILURE';

export const PAYMENTS_AUTHORIZE_REQUEST = 'PAYMENTS_AUTHORIZE_REQUEST';
export const PAYMENTS_AUTHORIZE_SUCCESS = 'PAYMENTS_AUTHORIZE_SUCCESS';
export const PAYMENTS_AUTHORIZE_FAILURE = 'PAYMENTS_AUTHORIZE_FAILURE';

export const PAYMENTS_DELETE_METHOD_REQUEST = 'PAYMENTS_DELETE_METHOD_REQUEST';
export const PAYMENTS_DELETE_METHOD_SUCCESS = 'PAYMENTS_DELETE_METHOD_SUCCESS';
export const PAYMENTS_DELETE_METHOD_FAILURE = 'PAYMENTS_DELETE_METHOD_FAILURE';

export const PAYMENTS_METHOD_PLANS_REQUEST = 'PAYMENTS_METHOD_PLANS_REQUEST';
export const PAYMENTS_METHOD_PLANS_SUCCESS = 'PAYMENTS_METHOD_PLANS_SUCCESS';
export const PAYMENTS_METHOD_PLANS_FAILURE = 'PAYMENTS_METHOD_PLANS_FAILURE';

export const PAYMENTS_METHOD_PLAN_CREATE_REQUEST =
  'PAYMENTS_METHOD_PLAN_CREATE_REQUEST';
export const PAYMENTS_METHOD_PLAN_CREATE_SUCCESS =
  'PAYMENTS_METHOD_PLAN_CREATE_SUCCESS';
export const PAYMENTS_METHOD_PLAN_CREATE_FAILURE =
  'PAYMENTS_METHOD_PLAN_CREATE_FAILURE';

export const PAYMENTS_METHOD_PLAN_UPDATE_REQUEST =
  'PAYMENTS_METHOD_PLAN_UPDATE_REQUEST';
export const PAYMENTS_METHOD_PLAN_UPDATE_SUCCESS =
  'PAYMENTS_METHOD_PLAN_UPDATE_SUCCESS';
export const PAYMENTS_METHOD_PLAN_UPDATE_FAILURE =
  'PAYMENTS_METHOD_PLAN_UPDATE_FAILURE';

export const PAYMENTS_METHOD_PLAN_DELETE_REQUEST =
  'PAYMENTS_METHOD_PLAN_DELETE_REQUEST';
export const PAYMENTS_METHOD_PLAN_DELETE_SUCCESS =
  'PAYMENTS_METHOD_PLAN_DELETE_SUCCESS';
export const PAYMENTS_METHOD_PLAN_DELETE_FAILURE =
  'PAYMENTS_METHOD_PLAN_DELETE_FAILURE';

export const PAYMENTS_CLEAR_ERROR = 'PAYMENTS_CLEAR_ERROR';
